import { withDependencies } from '@wix/thunderbolt-ioc'
import { ITpaSrcQueryParamProvider, ITpaSrcUtility, TpaSrcUtilitySymbol } from 'feature-tpa-commons'
import type { ITpaCompPreviewData, TpaPreviewData } from './types'
import type { DSCarmi } from 'thunderbolt-ds-carmi-root'
import { CarmiInstance } from '@wix/thunderbolt-symbols'

const allowedDeviceTypesForTPA = ['desktop', 'mobile']

export const TpaCompPreviewData = withDependencies(
	[TpaSrcUtilitySymbol, CarmiInstance],
	(
		{ rebuildTpasSrc, rebuildTpaSrc }: ITpaSrcUtility,
		carmiInstance: DSCarmi
	): ITpaCompPreviewData & ITpaSrcQueryParamProvider => {
		const dataStore: { [compId: string]: TpaPreviewData } = {}

		return {
			getTpaCompPreviewData(compId) {
				return { ...dataStore[compId] } // gosh somebody mutates the return value and then calls setTpaCompPreviewData() with it
			},
			setTpaCompPreviewData(compId, data) {
				const previousDeviceTypeForTPA = dataStore[compId]?.deviceTypeForTPA
				dataStore[compId] = data

				const sharedQueryParams = compId === 'sharedQueryParams'
				if (!sharedQueryParams && !data?.queryParams) {
					return
				}

				if (!sharedQueryParams) {
					rebuildTpaSrc(compId)
					return
				}

				if (
					sharedQueryParams &&
					data.deviceTypeForTPA &&
					data.deviceTypeForTPA !== previousDeviceTypeForTPA &&
					allowedDeviceTypesForTPA.includes(data.deviceTypeForTPA)
				) {
					carmiInstance.$runInBatch(() => {
						carmiInstance.deviceType.setFormFactorOverride(data.deviceTypeForTPA!)
						carmiInstance.deviceType.setFormFactor(data.deviceTypeForTPA!)
					})
					rebuildTpasSrc()
				}
			},
			getQueryParams({ compId }) {
				const deviceTypeForTPA = dataStore.sharedQueryParams?.deviceTypeForTPA!
				return {
					...(allowedDeviceTypesForTPA.includes(deviceTypeForTPA) ? { deviceTypeForTPA } : {}),
					...dataStore[compId]?.queryParams,
				}
			},
		}
	}
)
